import { linkedSignal, Service, Signal, signal } from '@angular/core';
import {
  assignPresenceSlots,
  PresenceColor,
  presenceColorForSlot,
} from '../utils/presence-color.util';

@Service()
export class PresenceColorService {
  private readonly source = signal<Signal<readonly string[] | null>>(
    signal(null)
  );

  // A null roster means the hub is not live, so holding the last slots over a reconnect keeps the
  // viewers who are still there on their colors once the next roster arrives.
  private readonly slots = linkedSignal<
    readonly string[] | null,
    ReadonlyMap<string, number>
  >({
    source: () => this.source()(),
    computation: (userIds, previous) =>
      userIds
        ? assignPresenceSlots(userIds, previous?.value)
        : (previous?.value ?? new Map()),
  });

  connect(userIds: Signal<readonly string[] | null>): void {
    this.source.set(userIds);
  }

  slotOf(userId: string): number | undefined {
    return this.slots().get(userId);
  }

  colorOf(userId: string): PresenceColor {
    return presenceColorForSlot(this.slotOf(userId) ?? 0);
  }
}
